import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShortcutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shortcut"}/>
}
